import { useMemo } from 'react'
import {
  getFormattedAddress,
  updatePhoneValueSearch,
} from '@sales-center/common'
import { BillTo } from '@user/store/entityLocations'

export type UseDataProps = {
  location: BillTo
  splitAddressIndex?: number
}

export function useData(props: UseDataProps) {
  const { location, splitAddressIndex = 50 } = props

  const properties = useMemo<string[]>(() => {
    const {
      firstName,
      lastName,
      company,
      address: {
        address: street1,
        address2: street2,
        city,
        postalCode,
        state: stateAbbreviation,
      },
      email,
      phone,
      phoneExt,
      altPhone,
      altPhoneExt,
    } = location

    const contactName = `${firstName ?? ''} ${lastName ?? ''}`.trim()
    const locationName = `${contactName}`.trim()
    const companyName = (company ?? '').trim()

    const address = getFormattedAddress(
      street1 ?? '',
      street2 ?? '',
      city ?? '',
      stateAbbreviation ?? '',
      postalCode ?? '',
    ).trim()

    const addrSplitIndex = address.lastIndexOf(',', splitAddressIndex)
    const addresses =
      splitAddressIndex && address && address.length > splitAddressIndex
        ? [
            address.slice(0, addrSplitIndex + 1),
            address.slice(addrSplitIndex + 1),
          ]
        : [address ?? '']

    const formPhone = updatePhoneValueSearch(phone ?? '')
    const formattedPhone = formPhone
      ? phoneExt !== ''
        ? `${formPhone} x${phoneExt}`
        : formPhone
      : ''

    const formAltPhone = updatePhoneValueSearch(altPhone ?? '')
    const formattedAltPhone = formAltPhone
      ? altPhoneExt !== ''
        ? `${formAltPhone} x${altPhoneExt}`
        : formAltPhone
      : ''

    return [
      locationName,
      companyName,
      ...addresses,
      email?.trim() ?? '',
      formattedPhone,
      formattedAltPhone,
    ].filter((x) => x.trim() !== '')
  }, [location, splitAddressIndex])

  return {
    properties,
  }
}
